import React, { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

import "./styles.scss";

import Timer from "@common/components/timer";
import { CashoutMoney } from "@app/dev/actions/terminal";
import { useTranslation } from "@common/hooks/translation";
import { RESET_UI_BY_IDLE_TIMER } from "@app/dev/actions/actionTypes";
import PaymentsService from "@app/dev/services/payments";
import { cashoutBalance } from "@app/dev/helpers/balance";

export const NonCashInactivePopup = ({ closePopup }) => {
  const t = useTranslation();
  const dispatch = useDispatch();

  const onReset = useCallback(async () => {
    await cashoutBalance();
    dispatch({ type: RESET_UI_BY_IDLE_TIMER });
    setTimeout(() => {
      PaymentsService.clearSessionBalanceState();
    }, 1000);
    closePopup();
  }, []);

  useEffect(() => {
    document.addEventListener("click", closePopup);

    return () => document.removeEventListener("click", closePopup);
  }, []);

  return (
    <div className="popup-content popup-small non-cash-inactive-popup">
      <h3 className="popup-title">{t("Session expiration warning")}</h3>
      <div className="popup-main-content">
        <p className="text-center">
          {t(
            "For your security, your balance will be cashed out to your OctoPay account after 120 seconds of inactivity. Please resume your activity to keep your session active."
          )}
        </p>
        <Timer onFinish={onReset} duration={10} variant="block" />
      </div>
    </div>
  );
};

NonCashInactivePopup.propTypes = {
  closePopup: PropTypes.func,
};
